
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","d":"M10 10.5h3m-3-2h3M8.5 12a2.3 2.3 0 0 0-.87-1.08 2.5 2.5 0 0 0-1.36-.42 2.5 2.5 0 0 0-1.372.388A2.3 2.3 0 0 0 4 11.946M1.5 5.328c0-.457.38-.828.848-.828h12.304c.468 0 .848.37.848.828v8.344c0 .457-.38.828-.848.828H2.348a.84.84 0 0 1-.848-.828zm6.145 3.675a1.48 1.48 0 1 1-2.96 0 1.48 1.48 0 0 1 2.96 0Z"}})])
          )
        }
      }
    